/* Arcade Cartridge — theme JS */
(function () {
  'use strict';

  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));

  /* ---------- Focus trap helper ---------- */
  function trapFocus(container, initial) {
    const focusable = $$('a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])', container);
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    (initial || first || container).focus();
    container._trap = (e) => {
      if (e.key !== 'Tab') return;
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    };
    container.addEventListener('keydown', container._trap);
  }
  function releaseFocus(container) {
    if (container._trap) container.removeEventListener('keydown', container._trap);
  }

  /* ---------- Mobile menu drawer ---------- */
  const menuDrawer = $('#MenuDrawer');
  if (menuDrawer) {
    const open = () => { menuDrawer.setAttribute('open', ''); document.body.classList.add('overflow-hidden'); trapFocus(menuDrawer, $('.menu-drawer__close', menuDrawer)); };
    const close = () => { menuDrawer.removeAttribute('open'); document.body.classList.remove('overflow-hidden'); releaseFocus(menuDrawer); $('.header__menu-toggle')?.focus(); };
    $$('[data-menu-open]').forEach((b) => b.addEventListener('click', open));
    $$('[data-menu-close]', menuDrawer).forEach((b) => b.addEventListener('click', close));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && menuDrawer.hasAttribute('open')) close(); });
  }

  /* ---------- Desktop dropdown menus ---------- */
  $$('.menu__item--has-children > .menu__link').forEach((btn) => {
    const sub = btn.nextElementSibling;
    if (!sub) return;
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const isOpen = btn.getAttribute('aria-expanded') === 'true';
      $$('.menu__item--has-children > .menu__link[aria-expanded="true"]').forEach((o) => { o.setAttribute('aria-expanded', 'false'); o.nextElementSibling.hidden = true; });
      btn.setAttribute('aria-expanded', String(!isOpen));
      sub.hidden = isOpen;
    });
  });
  document.addEventListener('click', (e) => {
    if (!e.target.closest('.menu__item--has-children')) {
      $$('.menu__item--has-children > .menu__link[aria-expanded="true"]').forEach((o) => { o.setAttribute('aria-expanded', 'false'); o.nextElementSibling.hidden = true; });
    }
  });

  /* ---------- Search modal + predictive search ---------- */
  const searchModal = $('#SearchModal');
  if (searchModal) {
    const input = $('input[type="search"]', searchModal);
    const results = $('.predictive', searchModal);
    const open = () => { searchModal.classList.add('is-open'); document.body.classList.add('overflow-hidden'); trapFocus(searchModal, input); };
    const close = () => { searchModal.classList.remove('is-open'); document.body.classList.remove('overflow-hidden'); releaseFocus(searchModal); };
    $$('[data-search-open]').forEach((b) => b.addEventListener('click', (e) => { e.preventDefault(); open(); }));
    $$('[data-search-close]', searchModal).forEach((b) => b.addEventListener('click', close));
    $('.search-modal__overlay', searchModal)?.addEventListener('click', close);
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && searchModal.classList.contains('is-open')) close(); });

    let timer;
    input?.addEventListener('input', () => {
      clearTimeout(timer);
      const q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ''; return; }
      timer = setTimeout(async () => {
        try {
          const res = await fetch(`${window.routes.predictive_search_url}?q=${encodeURIComponent(q)}&resources[type]=product,collection&resources[limit]=6&section_id=predictive-search`);
          const html = await res.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          results.innerHTML = doc.querySelector('#shopify-section-predictive-search')?.innerHTML || '';
        } catch (err) { results.innerHTML = ''; }
      }, 250);
    });
  }

  /* ---------- Cart drawer ---------- */
  const cartDrawer = $('#CartDrawer');
  const cartType = document.body.dataset.cartType || (cartDrawer ? 'drawer' : 'page');

  function openCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    document.body.classList.add('overflow-hidden');
    trapFocus(cartDrawer, $('.cart-drawer__close', cartDrawer));
  }
  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    document.body.classList.remove('overflow-hidden');
    releaseFocus(cartDrawer);
  }
  if (cartDrawer) {
    $$('[data-cart-close]', cartDrawer).forEach((b) => b.addEventListener('click', closeCartDrawer));
    $('.cart-drawer__overlay', cartDrawer)?.addEventListener('click', closeCartDrawer);
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && cartDrawer.classList.contains('is-open')) closeCartDrawer(); });
    $$('[data-cart-open]').forEach((b) => b.addEventListener('click', (e) => { e.preventDefault(); refreshCartSections().then(openCartDrawer); }));
  }

  async function refreshCartSections() {
    const sections = ['cart-drawer', 'cart-icon-bubble'];
    const mainCart = $('#MainCart');
    if (mainCart) sections.push(mainCart.dataset.sectionId);
    try {
      const res = await fetch(`${window.routes.cart_url}?sections=${sections.join(',')}`);
      const data = await res.json();
      applySections(data);
    } catch (e) { /* ignore */ }
  }

  function applySections(sections) {
    if (sections['cart-drawer'] && cartDrawer) {
      const doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
      const fresh = doc.querySelector('#CartDrawer');
      if (fresh) {
        $('.cart-drawer__body', cartDrawer).innerHTML = $('.cart-drawer__body', fresh).innerHTML;
        $('.cart-drawer__foot', cartDrawer).innerHTML = $('.cart-drawer__foot', fresh).innerHTML;
        $('.cart-drawer__head h2', cartDrawer).innerHTML = $('.cart-drawer__head h2', fresh).innerHTML;
      }
    }
    if (sections['cart-icon-bubble']) {
      const doc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
      const inner = doc.querySelector('#shopify-section-cart-icon-bubble') || doc.body;
      $$('[data-cart-icon-bubble]').forEach((el) => { el.innerHTML = inner.innerHTML; });
    }
    const mainCartEl = $('#MainCart');
    if (mainCartEl && sections[mainCartEl.dataset.sectionId]) {
      const doc = new DOMParser().parseFromString(sections[mainCartEl.dataset.sectionId], 'text/html');
      const fresh = doc.querySelector('#MainCart');
      if (fresh) mainCartEl.innerHTML = fresh.innerHTML;
    }
  }

  /* ---------- Add to cart (product forms + quick add) ---------- */
  document.addEventListener('submit', async (e) => {
    const form = e.target;
    if (!form.matches('form[data-ajax-cart]')) return;
    e.preventDefault();
    const btn = $('[type="submit"]', form);
    const errorBox = $('.product-form__error', form.closest('.product-form, .card') || form) || form.querySelector('.product-form__error');
    btn?.setAttribute('aria-busy', 'true');
    if (errorBox) { errorBox.hidden = true; errorBox.textContent = ''; }
    const fd = new FormData(form);
    const sections = ['cart-drawer', 'cart-icon-bubble'];
    fd.append('sections', sections.join(','));
    fd.append('sections_url', window.location.pathname);
    try {
      const res = await fetch(window.routes.cart_add_url, { method: 'POST', body: fd, headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' } });
      const data = await res.json();
      if (data.status) {
        if (errorBox) { errorBox.textContent = data.description || data.message; errorBox.hidden = false; }
        else alert(data.description || data.message);
      } else {
        applySections(data.sections || {});
        if (cartType === 'drawer' && cartDrawer) openCartDrawer();
        else window.location.href = window.routes.cart_url;
      }
    } catch (err) {
      if (errorBox) { errorBox.textContent = window.cartStrings.error; errorBox.hidden = false; }
    } finally {
      btn?.removeAttribute('aria-busy');
    }
  });

  /* ---------- Cart quantity / remove ---------- */
  async function changeLine(line, quantity, root) {
    const sections = ['cart-drawer', 'cart-icon-bubble'];
    const mainCart = $('#MainCart');
    if (mainCart) sections.push(mainCart.dataset.sectionId);
    root?.setAttribute('aria-busy', 'true');
    try {
      const res = await fetch(window.routes.cart_change_url, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity, sections, sections_url: window.location.pathname })
      });
      const data = await res.json();
      if (data.errors) {
        const err = root?.querySelector('.cart-item__error');
        if (err) err.textContent = data.errors;
        return;
      }
      applySections(data.sections || {});
    } finally { root?.removeAttribute('aria-busy'); }
  }
  document.addEventListener('click', (e) => {
    const remove = e.target.closest('[data-cart-remove]');
    if (remove) { e.preventDefault(); changeLine(Number(remove.dataset.line), 0, remove.closest('tr')); return; }
    const qbtn = e.target.closest('.quantity__button');
    if (qbtn) {
      const input = $('.quantity__input', qbtn.closest('.quantity'));
      const min = Number(input.min || 0);
      let v = Number(input.value || 0) + (qbtn.dataset.dir === 'up' ? 1 : -1);
      if (v < min) v = min;
      input.value = v;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });
  document.addEventListener('change', (e) => {
    const input = e.target;
    if (input.matches('.quantity__input[data-line]')) changeLine(Number(input.dataset.line), Number(input.value), input.closest('tr'));
    if (input.matches('#CartNote')) {
      fetch(window.routes.cart_update_url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: input.value }) });
    }
  });

  /* ---------- Product: variant selection + media ---------- */
  $$('[data-product-form]').forEach((wrapper) => {
    const jsonEl = $('[data-product-json]', wrapper);
    if (!jsonEl) return;
    const product = JSON.parse(jsonEl.textContent);
    const idInput = $('input[name="id"]', wrapper);
    const priceEl = $('[data-price]', wrapper);
    const addBtn = $('[data-add-to-cart]', wrapper);
    const skuEl = $('[data-sku]', wrapper);
    const invEl = $('[data-inventory]', wrapper);
    const mediaRoot = $('[data-product-media]', wrapper.closest('.product') || document);

    const money = (cents) => {
      const fmt = wrapper.dataset.moneyFormat || '${{amount}}';
      const amount = (cents / 100).toFixed(2);
      return fmt.replace(/\{\{\s*amount\s*\}\}/, amount.replace(/\B(?=(\d{3})+(?!\d))/g, ','))
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ','));
    };

    function selectedOptions() {
      return product.options.map((_, i) => {
        const el = $(`[name="options[${CSS.escape(product.options[i])}]"]:checked, select[data-option-index="${i}"]`, wrapper);
        return el ? el.value : null;
      });
    }
    function findVariant(opts) {
      return product.variants.find((v) => v.options.every((o, i) => o === opts[i]));
    }
    function updateAvailability(opts) {
      product.options.forEach((name, i) => {
        $$(`[name="options[${CSS.escape(name)}]"]`, wrapper).forEach((input) => {
          const test = opts.slice(); test[i] = input.value;
          const match = product.variants.find((vv) => vv.options.every((o, j) => o === test[j]));
          const label = input.nextElementSibling;
          if (label) label.classList.toggle('is-unavailable', !(match && match.available));
        });
      });
    }
    function render() {
      const opts = selectedOptions();
      const variant = findVariant(opts);
      updateAvailability(opts);
      if (!variant) {
        addBtn.disabled = true; $('.btn__label', addBtn).textContent = window.variantStrings.unavailable; return;
      }
      idInput.value = variant.id;
      const url = new URL(window.location); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url);
      if (priceEl) {
        let html = `<span class="price__regular">${money(variant.price)}</span>`;
        if (variant.compare_at_price && variant.compare_at_price > variant.price) html += `<s class="price__compare">${money(variant.compare_at_price)}</s>`;
        priceEl.innerHTML = html;
      }
      if (skuEl) skuEl.textContent = variant.sku || '—';
      if (invEl) {
        const q = variant.inventory_quantity;
        if (variant.inventory_management && typeof q === 'number') {
          invEl.hidden = false;
          invEl.className = 'product__inventory ' + (q <= 0 ? 'product__inventory--low' : q <= Number(invEl.dataset.threshold || 5) ? 'product__inventory--low' : 'product__inventory--ok');
          invEl.textContent = q <= 0 ? invEl.dataset.textOut : q <= Number(invEl.dataset.threshold || 5) ? invEl.dataset.textLow.replace('[count]', q) : invEl.dataset.textOk;
        } else invEl.hidden = true;
      }
      addBtn.disabled = !variant.available;
      $('.btn__label', addBtn).textContent = variant.available ? window.variantStrings.addToCart : window.variantStrings.soldOut;
      if (variant.featured_media && mediaRoot) showMedia(variant.featured_media.id);
    }
    function showMedia(id) {
      if (!mediaRoot) return;
      $$('.media-item', mediaRoot).forEach((m) => m.classList.toggle('is-active', String(m.dataset.mediaId) === String(id)));
      $$('.product__thumb', mediaRoot).forEach((t) => t.classList.toggle('is-active', String(t.dataset.mediaId) === String(id)));
      $$('video', mediaRoot).forEach((v) => { if (!v.closest('.media-item.is-active')) v.pause(); });
    }
    wrapper.addEventListener('change', (e) => { if (e.target.matches('[name^="options["], select[data-option-index]')) render(); });
    mediaRoot?.addEventListener('click', (e) => { const t = e.target.closest('.product__thumb'); if (t) showMedia(t.dataset.mediaId); });
    if (product.variants.length > 1) render();
  });

  /* ---------- Facets auto-submit ---------- */
  const facetForm = $('#FacetsForm');
  if (facetForm) {
    let t;
    facetForm.addEventListener('change', () => { clearTimeout(t); t = setTimeout(() => facetForm.requestSubmit(), 300); });
    $('#SortBy')?.addEventListener('change', (e) => { const u = new URL(window.location); u.searchParams.set('sort_by', e.target.value); u.searchParams.delete('page'); window.location = u; });
  }
})();
